import { inject, Injectable } from '@angular/core';
import { Language } from '../../model/interfaces/language.interface';
import { Languages } from '../../model/enums/languages.enum';
import { LanguageDirection } from '../../model/enums/language-direction.enum';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private localStorageService = inject(LocalStorageService);
  private language: Language;

  setLanguage(lang: string) {
    this.language = {
      code: lang,
      direction: this.getLanguageDirection(lang),
    };
  }

  getLanguage(): Language {
    return this.language;
  }

  getTranslationLanguage(): string {
    return this.supportedTranslations.includes(this.language.code) ? this.language.code : 'en';
  }

  getLanguageDirection(langCode?: string): string {
    const code = langCode || this.language.code;
    return LanguageDirection[code as keyof typeof LanguageDirection] ?? LanguageDirection.DEFAULT;
  }

  readonly supportedTranslations = ['en', 'he'];

  constructor() {
    const savedLanguage = this.localStorageService.getItem('selectedLanguage');
    const browserLanguage: string = navigator.language.toLocaleLowerCase().split(',')[0].split('-')[0] ?? Languages.HE;
    const languageCode = savedLanguage || browserLanguage;
    this.language = {
      code: languageCode,
      direction: this.getLanguageDirection(languageCode),
    } as Language;
  }
}
